import { ReleaseReadModel } from "featureFlags/domain/release"
import { ReleaseReadModelFactory } from "featureFlags/features/getRelease/factory"
import {
  CurrentRegion,
  EnvCurrentRegion
} from "regionalisation/features/getRegion"

export class CurrentRegionRelease {
  private readonly releases: ReleaseReadModel
  private readonly region: CurrentRegion

  constructor(releases: ReleaseReadModel, region: CurrentRegion) {
    this.releases = releases
    this.region = region
  }

  isLiveInCurrentRegion = (flagName: string): boolean =>
    this.releases.getByName(flagName).isLiveIn(this.region.resolve())
}

export class CurrentRegionReleaseFactory {
  build = (): CurrentRegionRelease =>
    new CurrentRegionRelease(
      new ReleaseReadModelFactory().build(),
      new EnvCurrentRegion()
    )
}
